import { render } from "./FormAuthentication.vue?vue&type=template&id=bfc65da8"
import script from "./FormAuthentication.vue?vue&type=script&lang=js"
export * from "./FormAuthentication.vue?vue&type=script&lang=js"

import exportComponent from "/Users/freddy/lab/js/cassandratech/ersaf-reflui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__